export enum IconesEnum {
  Tool = "Outils",
  Mail = "Message",
  MessageCircle = "SMS",
  Coffee = "Service",
  BarChart2 = "Statistiques",
  DollarSign = "Monnaie",
  Bell = "Cloche",
  Codesandbox = "Divers",
}